import { render, staticRenderFns } from "./CustomInvoiceModal.vue?vue&type=template&id=45cedfb4"
import script from "./CustomInvoiceModal.vue?vue&type=script&lang=js"
export * from "./CustomInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./CustomInvoiceModal.vue?vue&type=style&index=0&id=45cedfb4&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports